module.exports = __webpack_public_path__ + "media/images/common/deadline_bg-f1bd5d9311e5c883a9e0648d187111a0.gif";